module.exports = __webpack_public_path__ + "media/images/icons/grupo_bi_2-15c8c2e4f3bd97be99ff09ac5e9a7279.svg";